
import { useEffect, useState, useRef } from 'react';
import '../assets/styles/endGame.css';
import { sc } from '../helper/constants';

const EndGame = ({names, winnerStatus, history, setScreen, newGameStart}) => {
  const [firstMessageShown, setFirstMessageShown] = useState(true);
  const [showButtons, setShowButtons] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [playerMessage, setPlayerMessage] = useState('');

  const startTimer1 = () => {
    setTimeout(() => {
      setFirstMessageShown(false);
      startTimer2();
    }, 5000);
  }

  const startTimer2 = () => {
    setTimeout(() => setShowButtons(true), 3000);
  }

  useEffect(() => {
    if (winnerStatus === 1) { setPlayerMessage(names.player1 + ' wins'); }
    else if (winnerStatus === 2) { setPlayerMessage(names.player2 + ' wins'); }
    else { setPlayerMessage('DRAW!'); };
  }, [winnerStatus]);

  const resetGame = () => {
    setScreen(sc.login);
    localStorage.clear();
  }

  return (
    <div className='darkBK' onLoad={startTimer1()} >
      <div className="endgame" >
        <div className='modalHeader'>End Game</div>
          {(firstMessageShown) && <div className='playerWins'>{playerMessage}</div>}
          {(showButtons) &&
            <div className='endButtons'>
              <button className='againBtn' key={'again'} onClick={() => {newGameStart()}}>Want try again?</button>
              <button className='resetBtn' key={'reset'} onClick={() => {resetGame()}}>Reset</button>
              <button className='historyBtn' key={'history'} onClick={() => {setShowHistory(!showHistory)}}>Show history</button>
            </div>
          }
          {(((!firstMessageShown) && (!showButtons)) || (showHistory))
            && history.map((game, index) => (
              <div className='historyTable' key={index}>
                <div className='historyRowFirst' key={index+'a'}>{game.date}</div>   
                <div className='historyRow' key={index+'b'}>{game.player1} vs {game.player2}</div>    
                <div className='historyRow' key={index+'c'}>{game.winner}{(game.winner !== 'draw') && (' won')}</div>
              </div>
          ))}
      </div> 
    </div>
  );
}

export default EndGame;
